import { Box, Dialog, DialogContent, Divider } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import AppCard from '@crema/core/AppCard'
import { Close } from '@mui/icons-material'

const DialogModal = ({ open, handleClose, children, title, size, disableEscapeKeyDown = false }) => {
    return (
        <Dialog fullWidth open={open} maxWidth={size} onClose={handleClose} disableEscapeKeyDown={disableEscapeKeyDown}>
            <DialogContent sx={{ p: 0 }}>
                <AppCard
                    sxStyle={{ height: 1 }}
                    title={title}
                    titleStyle={{ fontSize: '20px' }}
                    action={
                        <>
                            <Box
                                onClick={handleClose}
                                component='span'
                                sx={{
                                    ml: 'auto',
                                    mt: 1.5,
                                }}
                            >
                                <Close
                                    sx={{
                                        cursor: 'pointer',
                                    }}
                                />
                            </Box>
                        </>
                    }
                >
                    <Divider />
                    <Box sx={{ pt: 5 }}>
                        {children}
                    </Box>
                </AppCard>
            </DialogContent>
        </Dialog>
    )
}

DialogModal.propTypes = {
    size: PropTypes.string,
    title: PropTypes.any,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    children: PropTypes.any,
    disableEscapeKeyDown: PropTypes.bool,
}
export default DialogModal
